Object.defineProperty(exports,"__esModule",{value:true});exports.default=immutableDate;function immutableDate(date){
date=new Date(date);
[
'setDate',
'setFullYear',
'setHours',
'setMilliseconds',
'setMinutes',
'setMonth',
'setSeconds',
'setTime',
'setUTCDate',
'setUTCFullYear',
'setUTCHours',
'setUTCMilliseconds',
'setUTCMinutes',
'setUTCMonth',
'setUTCSeconds',
'setYear'].
forEach(function(key){
date[key]=function(){
throw new Error('[remx] attempted to call Date#'+
key+', modifying dates in store are disallowed, create a new Date instead');

};
});
return date;
}